import Vue from 'vue';
import router from '@/router';
import VueAnalytics from 'vue-analytics';

Vue.use(VueAnalytics, {
  id: 'UA-189614238-1',
  router,
  ignoreRoutes: ['auth', 'faq', 'faq-docs', 'docs', 'info'],
});



// WEBPACK FOOTER //
// ./src/plugins/vue-analytics.js